<template>
  <div class="all-app-tile inner-box overflow-hidden tile cursor-pointer">
    <div class="" @click="handleAddYourApplication(app)">
      <svg class="application_toolbar_toggle" @click="toggleApplicationToolbar">
        <use xlink:href="#dots-vertical"></use>
      </svg>
      <div
        class="application_toolbar"
        :class="{ active: showApplicationToolbar }"
        @mouseleave="toggleApplicationToolbar"
      >
        <p v-if="$can('applications.update')" class="application_tool" @click="editApplication(app)">
          <svg class="icon">
            <use xlink:href="#edit-icon"></use>
          </svg>
          {{ trans('common.edit') }}
        </p>
        <p v-if="$can('applications.delete')" class="application_tool" @click="deleteApplication()">
          <svg class="icon">
            <use xlink:href="#delete-icon"></use>
          </svg>
          {{ trans('common.delete') }}
        </p>
      </div>
      <div class="px-6 pt-4 pb-2 gap-4 text-center">
        {{ applicationName }}<br />
        ({{ app.alias }})
      </div>
      <div class="px-6 pt-4 pb-2 gap-4 my-1 text-center">
        <img :alt="app.application.name" :src="logo" height="90px" width="90px" />
      </div>
    </div>
    <application-delete-modal
      :name="`confirmation-${app.id}`"
      :user="user"
      :app="{ id: app.id, name: applicationName, alias: app.alias }"
      @deleted-your-app="handleDeletedYourApp"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import ApplicationDeleteModal from '@/components/Dashboard/Application/DeleteModal';

export default {
  name: 'ApplicationCard',

  components: {
    ApplicationDeleteModal,
  },

  props: {
    user: Object,

    logo: {
      type: String,
      required: true,
    },

    app: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showApplicationToolbar: false,
    isDeleteModalOpen: false,
  }),

  computed: {
    applicationName() {
      return this.app.application.name;
    },
  },
  methods: {
    toggleApplicationToolbar() {
      this.showApplicationToolbar = !this.showApplicationToolbar;
    },

    handleAddYourApplication(app) {
      if (this.showApplicationToolbar || this.isDeleteModalOpen || !this.$can('applications.view')) {
        return;
      }

      this.$parent.$emit('your-application-selected', app);
    },

    editApplication(app) {
      this.$parent.$emit('your-application-selected', app);
    },

    deleteApplication() {
      this.isDeleteModalOpen = true;
      this.$vfm.show(`confirmation-${this.app.id}`);
    },

    handleDeletedYourApp(appId) {
      this.$emit('deleted-your-app', appId);
    },

    handleClosed() {
      this.isDeleteModalOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
.application {
  &_tool {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;

    & + & {
      padding-top: 0.75rem;
    }

    svg {
      --length: 1rem;
      height: var(--length);
      width: var(--length);
    }

    &bar {
      width: 100%;
      max-width: 11.5rem;
      position: absolute;
      z-index: 1;
      right: 1rem;
      top: 2.5rem;
      background: var(--light);
      padding: 1rem;
      border: 2px solid var(--table-row-color);
      border-radius: 0.5rem;

      &:not(.active) {
        display: none;
      }

      &_toggle {
        height: 1.25rem;
        width: 1.25rem;
        position: absolute;
        right: 0.5rem;
        top: 0.5rem;
      }
    }
  }
}
</style>
